import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import SeoHead from '@/components/feature/SeoHead';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import HotRanking from './components/HotRanking';
import LatestUpdates from './components/LatestUpdates';
import CompletedWorks from './components/CompletedWorks';
import MetaCafe from './components/MetaCafe';
import FaqSection from './components/FaqSection';

const faqData = [
  {
    q: '在57漫画网如何免费阅读漫画？',
    a: '无需注册登录，进入作品详情页点击任意章节即可开始下拉式免费阅读。韩漫与热门漫画均提供高清无删减版本，滑动页面即可连续翻页。',
  },
  {
    q: '《炸裂吧！巨棒》多久更新一次？',
    a: '该作品每周三、周日双更，最新章节会第一时间同步上线，可在作品页查看最近更新时间与最新章节标题。',
  },
  {
    q: '为什么下拉式阅读更流畅？',
    a: '平台采用瀑布流分镜加载与智能预加载技术，滑动即读、无需手动翻页，并自动记录阅读进度，下次打开无缝续读。',
  },
  {
    q: '什么是阅读元宇宙社交？',
    a: '这是57漫画网打造的社交阅读玩法：读者可在虚拟漫画咖啡馆中创建化身，与其他读者交流阅读心得、组队追更、参加主题分享会。',
  },
  {
    q: '网站上的漫画是否无删减？',
    a: '平台内的韩漫与国产漫画均提供无删减高清版本，力求原汁原味呈现作者创作。',
  },
  {
    q: '遇到加载或阅读问题怎么办？',
    a: '可以尝试刷新页面或切换网络环境；若问题依旧存在，可通过关于我们页面的联系表单或客服邮箱 support@57mh.net 反馈。',
  },
];

const homeJsonLd = [
  {
    '@type': 'WebPage',
    '@id': 'https://readfunny0.github.io/#webpage',
    url: 'https://readfunny0.github.io/',
    name: '《炸裂吧!巨棒》漫画-下拉式免费阅读漫画-57漫画网',
    description: '下拉式免费阅读漫画《炸裂吧！巨棒》在57漫画网得到精心呈现，提供阅读元宇宙社交，在虚拟漫画咖啡馆中与其他读者化身交流阅读心得。',
    isPartOf: { '@id': 'https://readfunny0.github.io/#website' },
    about: { '@id': 'https://readfunny0.github.io/#organization' },
    inLanguage: 'zh-CN',
  },
  {
    '@type': 'FAQPage',
    '@id': 'https://readfunny0.github.io/#faq',
    mainEntity: faqData.map((f) => ({
      '@type': 'Question',
      name: f.q,
      acceptedAnswer: { '@type': 'Answer', text: f.a },
    })),
  },
];

export default function Home() {
  return (
    <>
      <SeoHead
        title="《炸裂吧!巨棒》漫画-下拉式免费阅读漫画-57漫画网"
        description="《炸裂吧!巨棒》,下拉式免费阅读,漫画,57漫画网,无删减,韩漫 下拉式免费阅读漫画《炸裂吧！巨棒》在57漫画网得到精心呈现。提供阅读元宇宙社交，在虚拟漫画咖啡馆中与其他读者化身交流阅读心得。"
        keywords="炸裂吧巨棒,下拉式免费阅读,漫画,57漫画网,无删减,韩漫"
        canonicalPath="/"
        jsonLd={homeJsonLd}
      />
      <SiteHeader overlay />
      <main>
        <HeroSection />
        <div className="py-10 md:py-14">
          <CategoryNav />
        </div>
        <HotRanking />
        <LatestUpdates />
        <CompletedWorks />
        <MetaCafe />
        <FaqSection />
      </main>
      <SiteFooter />
    </>
  );
}